import { Line, mixins } from 'vue-chartjs'
const { reactiveProp } = mixins

export default {
  extends: Line,
  mixins: [reactiveProp],
  props: ['chartData', 'options'],
  watch: {
    'options': function () {
       this.reRenderChart()
     }
  },
  async created() {
    await new Promise(resolve => this.$nextTick(resolve))
    this.reRenderChart()
  },
  methods: {
    reRenderChart() {
      // this.chartData is created in the mixin.
      // If you want to pass options please create a local options object
      this.renderChart (this.chartData, this.options)
    }
  },
}



// WEBPACK FOOTER //
// ./src/data/LineChart.js